import axios from 'axios'

const UserService = {
  async get (params = {}) {
    return axios.get('admin/users', { params })
  },

  async post (params = {}) {
    return axios.post('admin/users', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`admin/users/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`admin/users/${data.id}`, { data })
  }
}

export default UserService
